<template>
  <a>
    <template v-for="message in messages">
      <span class="modal-body-text">{{message}}</span><br/>
    </template>
  </a>
</template>

<script>
export default {
  name: 'modal-body-show-info',
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="less">

</style>




// WEBPACK FOOTER //
// ModalInfoBody.vue?2fe749d2